function validateEmail(emailInput, emailError, checkAsRequired) {
    const email = emailInput.value.trim();
    if (checkAsRequired && email === '') {
        showErrorMessage(emailError, checkAsRequired);
        return false;
    }

    if (
        email !== '' &&
        !email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ) {
        showErrorMessage(
            emailError,
            'Invalid email format'
            // 'Check your email for errors, such as missing "@" or a period.'
        );

        return false;
    }

    hideErrorMessage(emailError);
    return true;
}
